<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <help :text="$t('help.content')" :title="$t('help.content_title')"/>

    <filters
      class="white-container"
      v-if="filters"
      :inputs="filters"
      @filter="filter"
      :extendButton="false"
      :extended="true"
      :loading="loading"
    >
    </filters>

    <div class="position-relative">

      <loader v-if="loading"/>

      <v-server-table
        name="contentTable"
        class="white-container content-table"
        url="/admin/content"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true">

        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{$t('global.showing')}}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
        </template>
        <template slot="title" slot-scope="props">
          <a v-if="props.row.link" :title="props.row.link" :href="props.row.link"
             target="_blank">{{props.row.title}}</a>
          <span v-else>{{props.row.title}}</span>
        </template>
        <template slot="created_at" slot-scope="props">
          <column-date :row="props.row" column="created_at" format="L"/>
        </template>
        <template slot="price" slot-scope="props">
          <priceInput :row="props.row" />
        </template>
        <template slot="extra" slot-scope="props">
          <column-extra-expand :row="props.row" column="extra" field="custom_field_test" image="image"/>
        </template>
        <template slot="taxonomies" slot-scope="props">
          <column-taxonomies-expand :row="props.row" column="taxonomies"/>
        </template>

      </v-server-table>
    </div>
  </div>

</template>

<script>
  import axios from '@/utils/axios';
  import {Event} from 'vue-tables-2';
  import contentFilters from './contentFilters.js';
  import filters from '@/components/global/filters';
  import priceInput from '@/components/global/priceInput';
  import CentsToBills from "../../components/table/CentsToBills.vue";
  import ColumnExtraExpand from "../../components/table/ColumnExtraExpand.vue";
  import i18n from "@/utils/i18n";
  import ColumnTaxonomiesExpand from "../../components/table/ColumnTaxonomiesExpand.vue";

  export default {
    middleware: 'auth',
    name: 'Content',
    components: {
      ColumnTaxonomiesExpand,
      ColumnExtraExpand,
      CentsToBills,
      filters,
      priceInput
    },
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        params: {
          page: 1,
          filter: {}
        },
        columns: ['title', 'price', 'content_type', 'taxonomies', 'created_at'],
        filters: contentFilters,
        options: {
          skin: [],
          headings: {
            title: i18n.t('form.title'),
            price: i18n.t('form.price'),
            content_type: i18n.t('form.content_type'),
            taxonomies: i18n.t('form.taxonomies'),
            created_at: i18n.t('form.created_at')
          },
          sortable: [],
          dateColumns: ['created_at', 'updated_at'],
          columnsDropdown: false,
          filterByColumn: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: {
                limit: data.limit,
                filter: data.custom,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.contentTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    methods: {
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.contentTable.filter::custom', params)
      },
    },
    destroyed() {
      Event.$off('vue-tables.contentTable.loaded');
    }
  }
</script>
